// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"443":"5ffc58f0","445":"040380e0","453":"5a536778","850":"4a968318","964":"13fd27c1"}[chunkId] + ".chunk.js";
};